import {createUseStyles} from 'react-jss';

const progressWidths = {
  1: '16%',
  2: '50%',
  3: '84%',
};

export default createUseStyles({
  progressBar: {
    width: '100%',
    backgroundColor: props => props.theme.core.background,
    padding: 12,
  },
  
  progressLine: {
    position: 'absolute',
    width: '100%',
    borderTop: '2px solid #bebebe',
    bottom: '45%',
    left: 0,
    
    '&:after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      borderTop: props => (`2px solid ${props.theme.progressBar.colour}`),
      width: props => (progressWidths[props.checkoutProgressStep]),
      transition: 'width 0.8s ease-out',
    },
  },
});
